module.exports = __webpack_public_path__ + "img/payu_installments.9ff134b2.png";